// extracted by mini-css-extract-plugin
module.exports = {"loader-mask-wrapper":"_4f720283bf--loader-mask-wrapper--ktpd0","loader-mask-spinner":"_4f720283bf--loader-mask-spinner--tHErE"};